import React from 'react';
import { Lang, EVENTS } from 'shared/constants';
import classNames from 'classnames';
import analyticsService from '../../helpers/analytics.service';
import { LangIcon } from '../../images/ui';
import { Button } from '../core';
import { IconButton } from '../design-system/buttons';
import { Popup } from '../common';
import styles from './lang-selector.module.scss';
import { LangSelectorImage } from '../../images/characters';

const LangSelectorComponent = ({
  lang = Lang.LANG_SELECTOR,
  options = [],
  setLang,
  className,
  langTooltip = Lang.ACTION_BUTTON_TOOLTIPS,
}) => {
  const [langSelectorState, setLangSelector] = React.useState(false);

  const openLangSelector = () => {
    analyticsService.track(EVENTS.LANGUAGE_SELECTOR.OPEN);
    setLangSelector(true);
  };

  const closeLangSelector = () => {
    setLangSelector(false);
  };

  const selectLang = key => {
    analyticsService.track(EVENTS.LANGUAGE_SELECTOR.SELECT_LANG, { key });
    setLang({ key });
    closeLangSelector();
  };

  return (
    <>
      <IconButton
        label={langTooltip.CHANGE_LANGUAGE}
        onClick={openLangSelector}
        className={classNames(styles.lang, className)}
      >
        <img src={LangIcon} alt="" />
      </IconButton>
      <Popup className={styles.popup} isOpen={langSelectorState} title={lang.HEADER}>
        <img src={LangSelectorImage} alt={lang.HEADER} className={styles.image} />
        <div className={styles.langList}>
          {options?.map(({ key, label }) => (
            <button className={styles.selectLang} onClick={() => selectLang(key)} key={key}>
              {label}
            </button>
          ))}
        </div>
        <Button className={styles.button} onClick={closeLangSelector}>
          {lang.DISMISS}
        </Button>
      </Popup>
    </>
  );
};

export { LangSelectorComponent };
